export default (tourProducts) => {
    if (!tourProducts?.length) return [];

    return _.values(tourProducts.reduce((group, productData) => {
        const product = productData.get('product') || productData.get('tour');
        const nights = product.get('nights');
        const nightsInHotel = product.get('nightsInHotel') !== undefined ? product.get('nightsInHotel') : nights;
        const date = product.get('startDate');
        const meal = product.get('meal').get('id');
        const room = product.get('room');
        const operator = product.get('operator');
        const roomCategory = room.category || `${operator.id}_${room.name}`;
        const tourKey = `${nights}_${nightsInHotel}_${date}_${meal}_${roomCategory}`;

        if (group[`${tourKey}_${room.beds}`]) {
            group[`${tourKey}_${room.beds}`].push(productData);
        } else {
            // eslint-disable-next-line no-param-reassign
            group[`${tourKey}_${room.beds}`] = [productData];
        }

        if (group[`${tourKey}_null`] && room.beds) {
            group[`${tourKey}_null`].push(productData);
        }

        return group;
    }, {}));
};